import React, { Component } from 'react'
import styled from 'styled-components'
import { Button, Modal } from 'advenio-components'
import { connect } from 'react-redux'
import CreditCard from '../../CreditCard'
import ActivateCardModal from '../../ProfileViews/ActivateCardModal'
import AuthorizeModal from '../../ProfileViews/AuthorizeModal'
import CardActions from '../../../Data/Redux/CardsRedux'
import UnvalidatedReceiptsActions from '../../../Data/Redux/UnvalidatedReceiptsRedux'
import { Selectors } from '../../../Data/Redux/CountriesRedux'
import CreateCardModal from '../../ProfileViews/CreateCardModal'
import CreateCardModalPayU from '../../ProfileViews/CreateCardModalPayU'
import { CONEKTA_PUBLIC_ADV_KEY,CONEKTA_PUBLIC_EAM_KEY, SR_PAGO_PUBLIC_KEY ,PAYU_PUBLIC_KEY} from '../../../config'

const getModalToRender = (
  provider,
  { open, onClose, parent, sendCard, loading, errorAfterCreate, cards },
) => ({
  Conekta: (
    <CreateCardModal
      provider={provider}
      open={open}
      onClose={onClose}
      parent={null}
      sendCard={sendCard}
      loading={loading}
      errorAfterCreate={errorAfterCreate}
      forceDefault={cards && cards.length === 0}
    />
  ),
  // PayU: (
  //   <CreateCardModalPayU
  //     provider={provider}
  //     open={open}
  //     onClose={onClose}
  //     parent={parent}
  //     sendCard={sendCard}
  //     loading={loading}
  //     errorAfterCreate={errorAfterCreate}
  //     forceDefault={cards && cards.length === 0}
  //   />
  // ),
  // SrPago: (
  //   <CreateCardModal
  //     provider={provider}
  //     open={open}
  //     onClose={onClose}
  //     parent={null}
  //     sendCard={sendCard}
  //     loading={loading}
  //     errorAfterCreate={errorAfterCreate}
  //     forceDefault={cards && cards.length === 0}
  //   />
  //),
}[provider])

const Container = styled.div`
  width: 100%;
  height: 100%;
`
const ButtonContainer = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;
`
const Warning = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: #8e8a8a;

  @media (max-width:763px) {
    height: 80%;
    font-size: 20px;
    padding: 24px;
    box-sizing: border-box;
    text-align: center;
  }
`
const Title = styled.span`
  font-weight: bold;
  padding: 16px;
`

class CardsView extends Component {
  state = {
    authorized: [],
    unauthorized: [],
    authorizeCards: [],
    defaultCards: [],
    openActivate: false,
    openConfirm: false,
    openModal: false,
    auth: false,
    willDelete: false,
    currentCard: null,
    currentCardId: null,
    warning: true,
    width: window.innerWidth,
    parent: null,
  }

  componentWillMount = () => {
    const { student: { credit_cards }, parent, activeAccount } = this.props

    if (credit_cards) {
      const {
        authorized,
        unauthorized,
      } = credit_cards

      this.setState({
        authorized: authorized || [],
        authorizeCards: authorized.filter(card => !card.is_default),
        defaultCards: authorized.filter(card => card.is_default),
        unauthorized: unauthorized || [],
        warning: !(authorized.length > 0 || unauthorized.length > 0),
      })
    }

    if (parent) {
      const {id,first_name, last_name_paternal} = parent

      this.setState({
        parent: {
          parent_id:id,
          first_name,
          last_name_paternal,
        },
      })
    }

    if (activeAccount) {
      this.setState({ openModal: true })
    }
  }

  componentDidMount = () => {
    const { student } = this.props
    if( student.center.id === 12){
      Conekta.setPublicKey(CONEKTA_PUBLIC_EAM_KEY)
    }else{
      Conekta.setPublicKey(CONEKTA_PUBLIC_ADV_KEY)
    }
    // SrPago.setPublishableKey(SR_PAGO_PUBLIC_KEY)
    // SrPago.setLiveMode(false)
    // payU.setPublicKey(PAYU_PUBLIC_KEY)
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps = (nextProps) => {
    const { student: { credit_cards } } = nextProps

    if (!credit_cards) {
      return false
    }

    const {
      authorized,
      unauthorized,
    } = credit_cards

    this.setState({
      authorized: authorized || [],
      authorizeCards: authorized.filter(card => !card.is_default),
      defaultCards: authorized.filter(card => card.is_default),
      unauthorized: unauthorized || [],
      warning: !(authorized.length > 0 || unauthorized.length > 0),
    })
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    const width = window.innerWidth
    this.setState({ width })
  }

  openActivate = (cardId, willDelete) => {
    const { student: { credit_cards } } = this.props
    const currentCard = credit_cards.authorized.find(card => card.id === cardId)
      || credit_cards.unauthorized.find(card => card.id === cardId)

      this.setState({
      currentCard,
      currentCardId: cardId,
      openActivate: true,
      willDelete,
    })
  }

  openConfirmation = (cardId, auth) => {
    const { student: { credit_cards } } = this.props
    const currentCard = credit_cards.authorized.find(card => card.id === cardId)
      || credit_cards.unauthorized.find(card => card.id === cardId)

    this.setState({
      auth,
      currentCard,
      currentCardId: cardId,
      openConfirm: true,
    })
  }

  handleDelete = () => {
    this.setState({ openActivate: false }, () => {
        this.props.deleteCard(this.state.currentCardId, true)
    })
  }

  handleUnauth = () => {
    this.setState({ openConfirm: false }, () => {
      this.props.unauthorizeCard(this.props.student.id, this.state.currentCardId, true)
    })
  }

  handleActivate = () => {
    this.setState({ openActivate: false }, () => {
      this.props.activateCard(this.props.student.id, this.state.currentCardId, true)
    })
  }

  handleAuth = () => {
    this.setState({ openConfirm: false }, () => {
      this.props.authorizeCard(this.props.student.id, this.state.currentCardId, true)
    })
  }

  openModal = () => {
    this.setState({
      openModal: true,
      card: {},
    })
  }

  sendCardInfo = (card_info) => {
    const {
      activeParentId,
      createCards,
      resetErrorCreate,
      student,
    } = this.props

    resetErrorCreate()
    createCards(student.id, activeParentId, card_info, true)
  }

  closeModal = () => {
    this.setState({
      openModal: false,
    }, () => {
      this.props.closeAccount()
      this.props.resetErrorCreate()
    })
  }

  render() {
    const {
      country,
      errorAfterCreate,
      loadingCreate,
      student,
      isDisenrolled
    } = this.props
    const {
      auth,
      authorized,
      authorizeCards,
      currentCard,
      defaultCards,
      openActivate,
      openConfirm,
      openModal,
      parent,
      unauthorized,
      warning,
      width,
      willDelete,
    } = this.state
    const propsToModal = {
      open: openModal,
      onClose: this.closeModal,
      parent,
      sendCard: this.sendCardInfo,
      loading: loadingCreate,
      errorAfterCreate,
      cards: authorized,
    }

    return (
      <Container>
        <ButtonContainer>
          <Button
            ghost
            small
            key="button"
            disabled={ Boolean(isDisenrolled)}
            onClick={this.openModal}
          >
            + Agregar Tarjeta
          </Button>
        </ButtonContainer>
        {!warning ?
          <div>
            {(defaultCards.length > 0 && authorizeCards.length > 0) &&
            <Title>Autorizadas</Title>
            }
            {defaultCards.map(card => (
              <CreditCard
                key={card.id}
                card={card}
                parent={null}
                auth={card.authorized_at}
                ParentPlatform
                onDelete={this.openActivate}
                onUnauth={this.openConfirmation}
                onAuth={this.openConfirmation}
                onActivate={this.openActivate}
              />
            ))}
            {authorizeCards.map(card => (
              <CreditCard
                key={card.id}
                card={card}
                parent={null}
                auth={card.authorized_at}
                ParentPlatform
                onDelete={this.openActivate}
                onUnauth={this.openConfirmation}
                onAuth={this.openConfirmation}
                onActivate={this.openActivate}
              />
            ))}
            {unauthorized.length > 0 &&
            <Title>No autorizadas</Title>
            }
            {unauthorized.map(card => (
              <CreditCard
                key={card.id}
                card={card}
                parent={null}
                auth={card.authorized_at}
                ParentPlatform
                onDelete={this.openActivate}
                onUnauth={this.openConfirmation}
                onAuth={this.openConfirmation}
                onActivate={this.openActivate}
              />
            ))}
            <AuthorizeModal
              card={currentCard}
              isBeingAuthorized={auth}
              isOpen={openConfirm}
              isSmallScreen={width < 763}
              onAuth={this.handleAuth}
              onClose={() => this.setState({ openConfirm: false })}
              onUnauth={this.handleUnauth}
              parent={parent}
              student={student}
            />
            <ActivateCardModal
              isOpen={openActivate}
              full={width < 763}
              onClose={() => this.setState({ openActivate: false })}
              onActivate={this.handleActivate}
              loading={false}
              willDelete={willDelete}
              onDelete={this.handleDelete}
              card={currentCard}
              parent={parent}
              student={student}
            />
          </div>
          :
          <Warning>
            Favor de agregar una tarjeta para poder pagar
          </Warning>
        }
        {country && getModalToRender(country.payment_provider, propsToModal)}
      </Container>
    )
  }
}
const mapStateToProps = ({ cards, ...state }) => ({
  country: Selectors.activeParentCountry(state),
  loadingCreate: cards.create.fetching,
  errorAfterCreate: cards.create.error,
  activeParentId: state.auth.user.userable_id,
  parent: state.auth.user,
  activeAccount: state.unvalidatedReceipts.toProfile,
})

const mapDispatchToProps = dispatch => ({
  deleteCard: (cardId, fromParent) => dispatch(CardActions.deleteRequest(cardId, fromParent)),
  resetErrorCreate: () => dispatch(CardActions.resetError()),
  createCards: (studentId, parentId, cardInfo, fromParent) =>
    dispatch(CardActions.createCardRequest(studentId, parentId, cardInfo, fromParent)),
  authorizeCard: (studentId, cardId, fromParent) =>
    dispatch(CardActions.authorizeRequest(studentId, cardId, fromParent)),
  unauthorizeCard: (studentId, cardId, fromParent) =>
    dispatch(CardActions.unauthorizeRequest(studentId, cardId, fromParent)),
  activateCard: (studentId, cardId, fromParent) => dispatch(CardActions.activateRequest(studentId, cardId, fromParent)),
  closeAccount: () => dispatch(UnvalidatedReceiptsActions.closeAccount()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CardsView)



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/CardsView/index.jsx